import { render, staticRenderFns } from "./originModule.vue?vue&type=template&id=484022e9&scoped=true"
import script from "./originModule.vue?vue&type=script&lang=js"
export * from "./originModule.vue?vue&type=script&lang=js"
import style0 from "./originModule.vue?vue&type=style&index=0&id=484022e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484022e9",
  null
  
)

export default component.exports